"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileIcon = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../icons");
var responsive_1 = require("../../utils/responsive");
var IconMap = {
    audio: icons_1.Audio,
    video: icons_1.Video,
    collection: icons_1.Collection,
    course: icons_1.Course,
    cheatsheet: icons_1.Cards,
};
var TileIcon = function (_a) {
    var icon = _a.icon, color = _a.color;
    var Icon = (0, styled_components_1.default)(IconMap[icon]).attrs(function (_a) {
        var theme = _a.theme;
        return ({
            primaryColor: color !== null && color !== void 0 ? color : theme.colors.text.secondary,
            height: 14,
            width: 14,
            'aria-hidden': true,
        });
    })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: 6px;\n    ", "\n  "], ["\n    flex-shrink: 0;\n    margin-right: 6px;\n    ", "\n  "])), (0, responsive_1.small)((0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-right: 4px;\n    "], ["\n      margin-right: 4px;\n    "])))));
    return react_1.default.createElement(Icon, null);
};
exports.TileIcon = TileIcon;
var templateObject_1, templateObject_2;
